import { useRef } from 'react';
import { useInView } from 'framer-motion';
import { FadeContainer, FadeText } from 'components/CustomAnimations';
import { ENV_CONFIG } from 'config/environment';

export const RealImpact = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  return (
    <div className="real-impact-container" ref={sectionRef}>
      <FadeContainer className="real-impact-title" animateNow={isInView} delay={0.2}>
        <FadeText className="eyebrow-text" text="Real Impact" progressive />
        <FadeText
          delay={0.2}
          progressive
          className="h1-dtm"
          text="Oath’s algorithm has consistently proven effective."
        />
      </FadeContainer>
      <div className="real-impact-text">
        <FadeText
          className="h4-text"
          text="While many organizations emphasize the win rate of candidates they support, that metric can mask poor decisions about which races to target."
          inViewTrigger
          delay={0.3}
        />
        <FadeText
          className="h4-text"
          text="Instead, Oath focuses on the percentage of funding directed to elections decided by less than 5% of votes because those are the races in which donations have the greatest impact."
          inViewTrigger
          delay={0.3}
        />
        <FadeText
          className="h4-text"
          text="Our algorithm is designed to help high-stakes candidates in close elections, who are currently underfunded."
          inViewTrigger
          delay={0.3}
        />
      </div>
      <FadeContainer inViewTrigger delay={0.3}>
        <video
          autoPlay
          loop
          muted
          playsInline
          id="Real impact media"
          controls
          className="real-impact-video"
        >
          <source
            src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/real-impact.mp4`}
            type="video/mp4"
          />
        </video>
      </FadeContainer>
      <div className="real-impact-footer">
        <FadeText
          className="h4-text"
          text="As we look at where the money went in 2024, $1B went to US Senate races. More than two-thirds of that $1B invested in US Senate races went to non-competitive races (decided by more than 5%)."
          inViewTrigger
          delay={0.3}
        />
        <FadeText
          className="h4-text"
          text="Seeing significant resources spent on safe seats, like Sen. Adam Schiff (California) who raised over $47M and won by over 17%, and long shots, like Gloria Johnson (Tennessee) who raised over $7.5M only to lose by more than 29%, tell us there is a smarter way."
          inViewTrigger
          delay={0.3}
        />
        <FadeText
          className="h4-text"
          text="Giving through Oath in 2024 looked different - with over two-thirds going to the races decided by the smallest margins."
          inViewTrigger
          delay={0.3}
        />
      </div>
    </div>
  );
};
